const encoder = new TextEncoder();
const xlsxMime = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
function escapeXml(value) {
    return value
        .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&apos;");
}
function normalizeFileName(fileName) {
    return fileName.replace(/\.[^.]+$/, "") + ".xlsx";
}
function normalizeSheetName(sheetName) {
    const normalized = sheetName.replace(/[\[\]:*?/\\]/g, " ").replace(/\s+/g, " ").trim();
    return (normalized || "Data").slice(0, 31);
}
function columnName(index) {
    let name = "";
    let value = index + 1;
    while (value > 0) {
        const remainder = (value - 1) % 26;
        name = String.fromCharCode(65 + remainder) + name;
        value = Math.floor((value - 1) / 26);
    }
    return name;
}
function cellXml(value, ref) {
    if (value == null || value === "") {
        return `<c r="${ref}"/>`;
    }
    if (typeof value === "number" && Number.isFinite(value)) {
        return `<c r="${ref}"><v>${value}</v></c>`;
    }
    if (typeof value === "boolean") {
        return `<c r="${ref}" t="b"><v>${value ? 1 : 0}</v></c>`;
    }
    const text = value instanceof Date ? value.toISOString() : String(value);
    return `<c r="${ref}" t="inlineStr"><is><t>${escapeXml(text)}</t></is></c>`;
}
function worksheetXml(rows) {
    const maxColumns = Math.max(1, ...rows.map((row) => row.length));
    const dimension = `A1:${columnName(maxColumns - 1)}${Math.max(1, rows.length)}`;
    const sheetData = rows
        .map((row, rowIndex) => {
        const rowNumber = rowIndex + 1;
        const cells = row.map((value, columnIndex) => cellXml(value, `${columnName(columnIndex)}${rowNumber}`)).join("");
        return `<row r="${rowNumber}">${cells}</row>`;
    })
        .join("");
    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><dimension ref="${dimension}"/><sheetData>${sheetData}</sheetData></worksheet>`;
}
function workbookXml(sheetName) {
    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><sheets><sheet name="${escapeXml(sheetName)}" sheetId="1" r:id="rId1"/></sheets></workbook>`;
}
function workbookRelsXml() {
    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/><Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>`;
}
function rootRelsXml() {
    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>`;
}
function contentTypesXml() {
    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/></Types>`;
}
function stylesXml() {
    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"><fonts count="1"><font><sz val="11"/><name val="Calibri"/></font></fonts><fills count="1"><fill><patternFill patternType="none"/></fill></fills><borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/></cellXfs></styleSheet>`;
}
const crcTable = Array.from({ length: 256 }, (_, index) => {
    let value = index;
    for (let bit = 0; bit < 8; bit += 1) {
        value = value & 1 ? 0xedb88320 ^ (value >>> 1) : value >>> 1;
    }
    return value >>> 0;
});
function crc32(data) {
    let crc = 0xffffffff;
    data.forEach((byte) => {
        crc = crcTable[(crc ^ byte) & 0xff] ^ (crc >>> 8);
    });
    return (crc ^ 0xffffffff) >>> 0;
}
function uint16(value) {
    return new Uint8Array([value & 0xff, (value >>> 8) & 0xff]);
}
function uint32(value) {
    return new Uint8Array([value & 0xff, (value >>> 8) & 0xff, (value >>> 16) & 0xff, (value >>> 24) & 0xff]);
}
function concat(parts) {
    const result = new Uint8Array(parts.reduce((total, part) => total + part.length, 0));
    let offset = 0;
    parts.forEach((part) => {
        result.set(part, offset);
        offset += part.length;
    });
    return result;
}
function zip(files) {
    const localParts = [];
    const centralParts = [];
    let offset = 0;
    files.forEach((file) => {
        const name = encoder.encode(file.name);
        const data = encoder.encode(file.content);
        const crc = crc32(data);
        const localHeader = concat([
            uint32(0x04034b50),
            uint16(20),
            uint16(0),
            uint16(0),
            uint16(0),
            uint16(0),
            uint32(crc),
            uint32(data.length),
            uint32(data.length),
            uint16(name.length),
            uint16(0),
            name,
            data
        ]);
        const centralHeader = concat([
            uint32(0x02014b50),
            uint16(20),
            uint16(20),
            uint16(0),
            uint16(0),
            uint16(0),
            uint16(0),
            uint32(crc),
            uint32(data.length),
            uint32(data.length),
            uint16(name.length),
            uint16(0),
            uint16(0),
            uint16(0),
            uint16(0),
            uint32(0),
            uint32(offset),
            name
        ]);
        localParts.push(localHeader);
        centralParts.push(centralHeader);
        offset += localHeader.length;
    });
    const centralStart = offset;
    const centralDirectory = concat(centralParts);
    const end = concat([
        uint32(0x06054b50),
        uint16(0),
        uint16(0),
        uint16(files.length),
        uint16(files.length),
        uint32(centralDirectory.length),
        uint32(centralStart),
        uint16(0)
    ]);
    const archive = concat([...localParts, centralDirectory, end]);
    const buffer = new ArrayBuffer(archive.byteLength);
    new Uint8Array(buffer).set(archive);
    return new Blob([buffer], { type: xlsxMime });
}
function buildXlsx(rows, sheetName) {
    const normalizedSheetName = normalizeSheetName(sheetName);
    return zip([
        { name: "[Content_Types].xml", content: contentTypesXml() },
        { name: "_rels/.rels", content: rootRelsXml() },
        { name: "xl/workbook.xml", content: workbookXml(normalizedSheetName) },
        { name: "xl/_rels/workbook.xml.rels", content: workbookRelsXml() },
        { name: "xl/styles.xml", content: stylesXml() },
        { name: "xl/worksheets/sheet1.xml", content: worksheetXml(rows) }
    ]);
}
function downloadBlob(blob, fileName) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = normalizeFileName(fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
export function downloadXlsx(rows, fileName, sheetName = fileName) {
    downloadBlob(buildXlsx(rows, sheetName), fileName);
}
